import * as API from "./base";

// // This is to match against your Facebook friends
export const index = (facebookFriendIds) =>
  API.get("/api/facebook_friends", { ids: facebookFriendIds.join(",") });
